<template>
    <el-tag :type="this.tableData.status(this.scope.row)">{{getText(tableData.bind)}}</el-tag>
</template>
<script>

    export default {
        name: "btn-click",
        props: ["tableData", "scope"],
        data() {
            return {
                data: this.tableData
            };
        },
        computed: {
            placeholder() {
                return this.btnClickEvent && this.btnClickEvent.length === 0;
            },
            btnClickEvent() {
                let btnList = [];

                if (typeof this.data.bind === "function") {
                    btnList = this.data.bind(this.scope.row);
                } else {
                    btnList = this.data.bind;
                }

                return btnList.filter(item => !item.showButton || item.showButton());
            }
        },
        methods: {
            getText(val) {
                if (typeof val === "function") {
                    return val(this.scope.row, this.scope.$index);
                } else {
                    return this.scope.row[val];
                }
            },
        }
    };
</script>
